import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  qualityConfigsApi,
  type CreateQualityConfigInput,
  type QualityConfig,
  type UpdateQualityConfigInput,
} from '@/lib/api/quality-configs.api';

const QK = ['quality-configs'];

export function useQualityConfigList() {
  return useQuery<QualityConfig[]>({ queryKey: QK, queryFn: qualityConfigsApi.list });
}

export function useQualityConfigDetail(id: string | undefined) {
  return useQuery<QualityConfig>({
    queryKey: [...QK, id],
    queryFn: () => qualityConfigsApi.getById(id!),
    enabled: !!id,
  });
}

export function useCreateQualityConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (data: CreateQualityConfigInput) => qualityConfigsApi.create(data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useUpdateQualityConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: UpdateQualityConfigInput }) =>
      qualityConfigsApi.update(id, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}

export function useDeleteQualityConfig() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => qualityConfigsApi.delete(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: QK }),
  });
}
